import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getDictionaryOptions } from '@/module/Author/Dictionary';
import { DictionaryEdit } from '@/module/Author/Dictionary/DictionaryEdit';

export const Route = createFileRoute('/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { dictionaryId } = Route.useParams();
  const { data: dictionary } = useSuspenseQuery(getDictionaryOptions(dictionaryId));

  return <DictionaryEdit dictionary={dictionary} />;
}
